var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.014 1.999c-5.523 0-10 4.477-10 10 0 1.272.262 2.561.72 3.719l.78 1.593c.495 1.029.321 1.999-.344 3.188a.984.984 0 0 0 .844 1.469c1.017.023 2.644-.395 3.938-.875 1.193.551 2.73.906 4.062.906 5.523 0 10-4.477 10-10s-4.477-10-10-10"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.55,
    cy: 11.95,
    r: 1.25,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.05,
    cy: 11.95,
    r: 1.25,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.55,
    cy: 11.95,
    r: 1.25,
    fill: "#fff"
  })));
};
export default SvgChat;